import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDispatch } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { DialogActions, TextareaAutosize, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import BoxHeader from '../../../../../../../../components/Layout/Components/Box/Header/BoxHeader';
import BoxHeaderIcon from '../../../../../../../../components/Layout/Components/Box/Header/BoxHeaderIcon';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';

const useStyles = makeStyles(() => ({ root: { overflow: 'visible' } }));
const NoteDialog = ({ open, handleClose, comment }) => {
  const [value, setValue] = useState(comment);
  const classes = useStyles();

  return <Dialog
    open={open}
    onClose={handleClose}
    classes={{ paperScrollPaper: classes.root }}
    maxWidth='sm'
    minWidth='sm'
  >
    <BoxHeader>
      <BoxHeaderIcon color={'#43a047'}>
        <div style={{ width: '30px', height: '30px', textAlign: 'center' }}>
          <CommentOutlinedIcon style={{ fontSize: '1.5em' }} />
        </div>
      </BoxHeaderIcon>
      <div style={{ padding: '0px', margin: '0px' }}>
        <h3 style={{ paddingTop: '10px', margin: '0px' }}>

        </h3>
      </div>
    </BoxHeader>
    <div style={{ minWidth: '300px', minHeight: '200px', overflow: 'hidden', padding: '15px' }}>
      <TextField
        fullWidth
        multiline
        rows={10}
        autoFocus
        value={value}
        onChange={(event) => setValue(event.target.value)}
      />
    </div>
    <DialogActions>
      <Button autoFocus onClick={handleClose} color='primary'>
        Zrušit
      </Button>
      <Button onClick={handleClose} color='primary'>
        Ok
      </Button>
    </DialogActions>
  </Dialog>;
};

export default NoteDialog;
